import { fetchUserApi } from './api'
import { fetchCompany } from './company'
import { fetchSizes } from './sizes'

export const SET_USER = 'SET_USER';
export const FETCHING_USER = 'FETCHING_USER';

export function setUser(user) {
  return {
    type: SET_USER,
    user: user
  };
}

function fetchingUser() {
  return { type: FETCHING_USER }
}

export function createCookie(token) {
  var expires = "";
  var date = new Date();
  var minutes = 30;
  date.setTime(date.getTime() + (minutes * 60 * 1000));
  expires = "; expires=" + date.toUTCString();
  document.cookie = "user_token=" + token + expires + "; path=/";
  document.cookie = "shipback_id=" + shipback_id + expires + "; path=/";
  document.cookie = "company_slug=" + company_id + expires + "; path=/"
}

export function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) {
    return parts.pop().split(";").shift();
  }
  else {
    return false
  }
}

export function fetchUser(shipback_id, user_agent) {
  return function (dispatch) {
    dispatch(fetchingUser())
    return fetchUserApi(shipback_id, user_agent)
    .then(json => {
      dispatch(setUser(json.auth_token))
      dispatch(fetchSizes(json.auth_token))
      dispatch(fetchCompany(company_id, json.auth_token))
    })
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/actions/user.js